import { Row, Col, Typography, Tag, Space } from 'antd';
import PropTypes from 'prop-types';

const { Text } = Typography;

export function CountStatus({ count }) {
	const { issued, cancelled } = count;
	return (
		<Row>
			<Space size="small">
				<Col>
					<Space>
						<Text>Issued</Text>
						<Tag color="green" style={{ width: '40px' }}>
							{issued}
						</Tag>
					</Space>
				</Col>
				<Col>
					<Space>
						<Text>Cancelled</Text>
						<Tag color="red" style={{ width: '40px' }}>
							{cancelled}
						</Tag>
					</Space>
				</Col>
				<Col>
					<Space>
						<Text>Total</Text>
						<Tag color="blue" style={{ width: '40px' }}>
							{issued + cancelled}
						</Tag>
					</Space>
				</Col>
			</Space>
		</Row>
	);
}

CountStatus.propTypes = {
	count: PropTypes.object,
};
